import React, { useState } from 'react';
import { Switch } from 'antd';
import { FormattedMessage } from 'react-intl';

const AutoTrain = () => {
  const [enabled, setEnabled] = useState(false);

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-700 font-medium">{<FormattedMessage id="AGENTS.HOME.AUTO_TRAIN" />}</span>
      <Switch defaultChecked onChange={() => setEnabled(v => !v)} />
    </div>
  );
};

export { AutoTrain }; 